
export class KlarnaOnsiteMessaging {

    constructor(code) {
        this.code = code;
        this.locales = 'cs-CZ'
        this.clientId = 'df25daca-c76d-5b43-a613-5c84257a0c11'
        this.environment = 'playground'
        this.init()
    }

    async init() {
        const message = document.getElementById(this.code);
        if (message) {
            const config = await this.fetchConfig();
            if (config && config.clientId && config.environment) {
                this.clientId = config.clientId;
                this.environment = config.environment;
                const data = JSON.parse(message.innerText);
                this.locales = data?.locales || this.locales;
                const jsElement = document.createElement('script')
                jsElement.setAttribute('src', 'https://js.klarna.com/web-sdk/v1/klarna.js')
                jsElement.setAttribute('data-environment', this.environment)
                jsElement.setAttribute('data-client-id', this.clientId)
                document.head.appendChild(jsElement)
    
                const klarnaMessage = document.createElement('klarna-placement');
                klarnaMessage.setAttribute('data-key', data?.dataKey);
                klarnaMessage.setAttribute('data-locale', this.locales);
                message.replaceWith(klarnaMessage);
            } else {
                console.log('Cannot find config.json in /public/js/');
            }
        }
    }

    fetchConfig() {
        return new Promise((resolve, reject) => {
            fetch('/public/js/config.json')
                .then(res => resolve(res.json()))
                .catch(e => reject(e));
        })
    }
}
